import React, { useState, useEffect, useContext } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Card,
  CardContent,
  Typography,
  IconButton,
  TablePagination,
  Tooltip,
  Box,
  Button,
  Popover,
} from "@mui/material";
import DeleteConfirmationModal from "../deleteConfirmationModal";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import CustomTypography from "../../globalStyles/fonts";
import { tableCellClasses } from "@mui/material/TableCell";
import SortingIcon from "../../globalStyles/icons/sorting-icon";
import { useTheme } from "@mui/styles";
import EditIcon from "../../globalStyles/icons/editIcon";
import ViewIcon from "../../globalStyles/icons/vieewIcon";
import DeleteIcon from "../../globalStyles/icons/deleteIcon";
import { styled } from "@mui/material/styles";
import ShippingCostDetailsModal from "../shipping-cost-details-modal";
import { shippingCostService } from "../../utils/services/shippingCostService";
import { isMobile } from "../../globalStyles/mobile";
import { toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomPagination from "../pagination";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#EEEEEE",
    border: "1px solid #EAECF0",
    padding: "4px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "4px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#FFFFFF",
    border: "1px solid #EAECF0",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#F6F6F6",
    border: "1px solid #EAECF0",
  },
  "&:lastChild td, &:lastChild th": {
    border: 0,
  },
}));

const ShipmentCostListView = ({
  viewMode,
  data,
  onEditData,
  onDeleteData,
  setPage,
  setRowsPerPage,
  rowsPerPage,
  page,
  dataCount,
  selectedShipmentCost,
  setSelectedShipmentCost,
}) => {
  const [deletingItemId, setDeletingItemId] = useState(null);
  const [shippigCostData, setShippigCostData] = useState([]);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const startIndex = rowsPerPage * page;
  const [anchorElPopover, setAnchorElPopover] = useState(null);
  const openPopover = Boolean(anchorElPopover);
  const deleteData = async () => {
    try {
      await shippingCostService.delete(deletingItemId);
      setOpenConfirmation(false);
      onDeleteData && onDeleteData();
      toast.success("Shipment Cost deleted successfully!");
    } catch (error) {
      toast.error("Failed to delete Shipment Cost");
      console.error("Delete failed:", error);
    }
  };
  const handleViewClick = (shipping) => {
    setOpenViewModal(true);
    handlePopoverClose();
  };
  const handleDeleteClick = (item) => {
    setDeletingItemId(item._id);
    setOpenConfirmation(true);
    handlePopoverClose();
  };

  const handlePopoverOpen = (event, item) => {
    setSelectedShipmentCost(item);
    event.stopPropagation();
    setAnchorElPopover(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorElPopover(null);
  };

  useEffect(() => {
    setShippigCostData(
      data?.map((item) => ({
        ...item,
        action: (
          <Box sx={{ display: "flex", boxShadow: "none" }}>
            <IconButton
              aria-label="more actions"
              onClick={(e) => handlePopoverOpen(e, item)}
              sx={{
                color: openPopover ? "primary" : "inherit",
              }}
            >
              <MoreVertIcon />
            </IconButton>
            <Popover
              open={Boolean(anchorElPopover)}
              anchorEl={anchorElPopover}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                "& .MuiPaper-root": {
                  boxShadow: "none",
                  border: "1px solid #EAECF0",
                  borderRadius: "4px",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px",
                  boxShadow: "none",
                  gap: 1,
                }}
              >
                <Button
                  style={{
                    color: "#333333",
                    justifyContent: "flex-start",
                    textTransform: "none",
                  }}
                  onClick={() => handleViewClick(item)}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-start"
                    width="100%"
                    gap={1}
                  >
                    <ViewIcon />
                    <Typography
                      fontFamily={"poppins"}
                      fontSize={"16px"}
                      color={"#333333"}
                      fontWeight={500}
                    >
                      View
                    </Typography>
                  </Box>
                </Button>

                <Button
                  style={{
                    color: "#333333",
                    justifyContent: "flex-start",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    onEditData && onEditData(selectedShipmentCost);
                    handlePopoverClose();
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-start"
                    width="100%"
                    gap={1}
                  >
                    <EditIcon />
                    <Typography
                      fontFamily={"poppins"}
                      fontSize={"16px"}
                      color={"#333333"}
                      fontWeight={500}
                    >
                      Edit
                    </Typography>
                  </Box>
                </Button>
                <Button
                  style={{
                    color: "#333333",
                    justifyContent: "flex-start",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    handleDeleteClick(item);
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-start"
                    width="100%"
                    gap={1}
                  >
                    <DeleteIcon />
                    <Typography
                      fontFamily={"poppins"}
                      fontSize={"16px"}
                      color={"#333333"}
                      fontWeight={500}
                    >
                      Delete
                    </Typography>
                  </Box>
                </Button>
              </Box>
            </Popover>
          </Box>
        ),
      }))
    );
  }, [data, anchorElPopover]);

  const NoDataImage = () => (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <img
        src="no_data_rateCard.png"
        alt="No data available"
        style={{ objectFit: "fill", height: "300px" }}
      />
    </div>
  );

  const renderGridView = () => (
    <Grid
      sx={{
        marginTop: "1px",
        maxHeight: "100%",
        paddingBottom: 5,
        overflow: "auto",
      }}
      container
      spacing={2}
    >
      {shippigCostData?.map((x, index) => (
        <Grid sx={{ paddingBottom: 1 }} item xs={12} sm={6} md={4} key={index}>
          <Card
            sx={{
              boxShadow: 3,
              cursor: "pointer",
              width: "100%",
              height: "100%",
              position: "relative",
              borderRadius: "6px",
              border: "1px solid #D0D5DD",
            }}
          >
            <CardContent>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  fontWeight="500"
                  sx={{ textAlign: "start" }}
                  fontFamily="Poppins"
                  color="#333333"
                >
                  {startIndex + index + 1}
                </Typography>
                <div
                  style={{
                    position: "absolute",
                    top: 5,
                    right: 5,
                  }}
                >
                  {x?.action}
                </div>
              </div>
              <Grid container spacing={1} mt={2}>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="#333333"
                  >
                    Client
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Tooltip
                    title={x?.client_id?.business_name || x?.client_id?.name}
                    arrow
                  >
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"#333333"}
                    >
                      : {x?.client_id?.business_name || x?.client_id?.name}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    Shipment Service
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Tooltip title={x?.shipment_service?.type} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"#333333"}
                    >
                      : {x?.shipment_service?.type}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    Min Weight
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Tooltip title={x.pricing.min_weight} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"#333333"}
                    >
                      : {x.pricing.min_weight}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    Max Weight
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Tooltip title={x.pricing.max_weight} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"#333333"}
                    >
                      : {x.pricing.max_weight}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    Price
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    : {x.pricing.price}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const renderListView = () => (
    <div
      style={{
        width: "100%",
        //overflow: isMobile() ? "auto" : "hidden",
        paddingBottom: 20,
      }}
    >
      <TableContainer
        className="custom-container"
        sx={{
          overflowY: "auto",
          paddingInline: 0.4,
          maxHeight: "100%",
        }}
      >
        <Table
          stickyHeader
          aria-label="sticky table"
          sx={{
            border: "1px solid #EAECF0",
          }}
        >
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="#333333"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  SL NO
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="#333333"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  CLIENT
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="#333333"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  SHIPMENT SERVICE
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="#333333"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  MIN WEIGHT
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="#333333"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  MAX WEIGHT
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="#333333"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  {"PRICE (USD)"}
                </Typography>
              </StyledTableCell>

              <StyledTableCell>
                <CustomTypography
                  fontSize="14px"
                  title={true}
                  color="#333333"
                  fontWeight={500}
                ></CustomTypography>
              </StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {shippigCostData?.map((x, index) => (
              <React.Fragment>
                <StyledTableRow key={index}>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"Poppins"}
                    >
                      {startIndex + index + 1}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"Poppins"}
                    >
                      {x?.client_id?.business_name || x?.client_id?.name}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"Poppins"}
                    >
                      {x?.shipment_service?.type}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"Poppins"}
                    >
                      {x.pricing.min_weight}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"Poppins"}
                    >
                      {x.pricing.max_weight}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"Poppins"}
                    >
                      {x.pricing.price}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell sx={{ width: "3%", textAlign: "center" }}>
                    {x?.action}
                  </StyledTableCell>
                </StyledTableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );

  return (
    <>
      <div sx={{ minWidth: "100%" }}>
        <div
          style={{
            overflowY: "scroll",
            display: "flex",
            maxHeight: `calc(100vh - 270px)`,
            width: "100%",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::WebkitScrollbar": { width: 0 },
          }}
        >
          {viewMode === "grid" || isMobile()
            ? renderGridView()
            : renderListView()}
        </div>
        <CustomPagination
          page={page}
          rowsPerPage={rowsPerPage}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          dataCount={dataCount}
          disableNext={dataCount <= rowsPerPage * (page + 1)}
        />
        <DeleteConfirmationModal
          DeleteConfirmationModal
          title={`Are you sure you want to delete ${selectedShipmentCost?.shipment_service?.type} ?`}
          open={openConfirmation}
          handleClose={() => setOpenConfirmation(false)}
          handleDelete={() => {
            deleteData();
          }}
        />
        <ShippingCostDetailsModal
          shippingCost={selectedShipmentCost}
          open={openViewModal}
          onClose={() => setOpenViewModal(false)}
        />
      </div>
    </>
  );
};

export default ShipmentCostListView;
